import { render, staticRenderFns } from "./CallingApiCenter.vue?vue&type=template&id=7dc24e23&scoped=true"
import script from "./CallingApiCenter.vue?vue&type=script&lang=js"
export * from "./CallingApiCenter.vue?vue&type=script&lang=js"
import style0 from "./CallingApiCenter.vue?vue&type=style&index=0&id=7dc24e23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc24e23",
  null
  
)

export default component.exports